"use client";
import React, { useSyncExternalStore } from "react";
import ThemeSwitcher from "components/ThemeSwitcher";
import { brandAssets } from "constants/brand";

interface AuthHeaderProps {
  lightLogo?: string;
  darkLogo?: string;
  alt?: string;
  langLabel?: string;
  onChangeLang?: () => void;
}

const logoStyle: React.CSSProperties = {
  maxWidth: "100%",
  height: "100%",
  objectFit: "contain",
};

const AuthHeader: React.FC<AuthHeaderProps> = ({ lightLogo, darkLogo, alt = "logo", langLabel, onChangeLang }) => {
  // Logo URLs come from the redux-persist store, which rehydrates from
  // localStorage before React hydrates — render the static fallbacks until
  // hydration completes so the first client render matches the server HTML.
  const hydrated = useSyncExternalStore(
    () => () => {},
    () => true,
    () => false,
  );

  return (
    <header className="header-mounted">
      <div className="header-wrap">
        <div className="logo" style={{ height: 48 }}>
          <img
            src={(hydrated && lightLogo) || brandAssets.lightLogo}
            alt={alt}
            className="logo-light-only"
            style={logoStyle}
          />
          <img
            src={(hydrated && darkLogo) || brandAssets.darkLogo}
            alt={alt}
            className="logo-dark-only"
            style={logoStyle}
          />
        </div>
        <div className="menu-block">
          {langLabel && onChangeLang && (
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); onChangeLang(); }}
              className="change-lang"
            >
              {langLabel}
            </a>
          )}
          <ThemeSwitcher />
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;
